import React from "react";

function StaffComingSoonPage() {
  return (
    <div
      style={{
        background: "#05070d",
        minHeight: "100vh",
        color: "#fff",
        padding: 24
      }}
    >
      <button
        onClick={() => window.location.href = "/staff"}
        style={{
          background: "#020b14",
          border: "1px solid #00f2ff",
          color: "#00f2ff",
          borderRadius: 10,
          padding: 12,
          fontWeight: "bold",
          cursor: "pointer"
        }}
      >
        ← Retour staff
      </button>

      <h1
        style={{
          color: "#00f2ff",
          marginTop: 30
        }}
      >
        Page staff en cours
      </h1>

      <p style={{ color: "#8fa6ad" }}>
        Cette section sera branchée ensuite.
      </p>
    </div>
  );
}

export default StaffComingSoonPage;
